"use client";
import { useState } from "react";
import { getCookie } from "helpers/cookies";

import { postNotification } from "bossjob-remote/dist/clientStorage";

import { postSaveJobService } from "store/services/jobs/postSaveJob";
import { deleteSaveJobService } from "store/services/jobs/deleteSaveJob";
import { Button } from "antd";
import Toast from "app/components/Toast";
import classNames from "classnames";
import { useSharedData } from "bossjob-remote/dist/hooks";
import styles from "./JobClient.pc.module.scss";

type propsType = {
  jobId: number;
  data: {
    [key: string]: any;
  };
};
const Save = (props: propsType) => {
  const { jobId: id, data } = props;

  const sessionid = getCookie("sessionid");
  const [isSave, setIsSave] = useState<boolean>(data?.is_save);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const dictionary = useSharedData("DICTIONARY");
  const header = dictionary?.jobDetail?.header ?? {};

  const handleSaveJob = () => {
    setSaveLoading(true);

    postSaveJobService({
      job_id: id
    })
      .then((res) => {
        if (res) {
          setIsSave(true);
          Toast.success(header?.savedSuccess);
        }
      })

      .finally(() => {
        setSaveLoading(false);
      });
  };

  const handleUnSaveJob = () => {
    setSaveLoading(true);

    deleteSaveJobService(id)
      .then((res) => {
        if (res) {
          setIsSave(false);
          Toast.success(header?.unSaveSuccess);
        }
      })
      .finally(() => {
        setSaveLoading(false);
      });
  };

  return (
    <Button
      className={classNames({
        [styles.saveButton]: true,
        [styles.savedButton]: isSave
      })}
      onClick={() => {
        if (!sessionid) {
          sessionStorage.setItem("redirectPage", window?.location?.pathname);
          postNotification("SHOW_LOGIN_MODAL");
          return;
        } else if (!isSave) {
          handleSaveJob?.();
        } else {
          handleUnSaveJob?.();
        }
      }}
    >
      {/* {isSave ? data.un_save_text : data.save_text} */}
      {!isSave ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='17'
          viewBox='0 0 18 17'
          fill='none'
        >
          <path
            d='M16.6441 8.26907C16.8848 8.0226 17.0536 7.71488 17.1322 7.37924C17.2108 7.0436 17.1961 6.69283 17.0898 6.36493C16.9918 6.03897 16.8038 5.74735 16.5476 5.52365C16.2913 5.29995 15.9771 5.15326 15.6412 5.10047L12.3428 4.60956C12.285 4.60115 12.2302 4.57836 12.1835 4.54328C12.1368 4.50819 12.0996 4.46194 12.0753 4.40874L10.5896 1.30709C10.4497 1.0031 10.2271 0.744797 9.94714 0.561897C9.66722 0.378998 9.34141 0.278929 9.0072 0.273202C8.6667 0.272111 8.33319 0.369898 8.04707 0.55472C7.76095 0.739541 7.53449 1.00347 7.39513 1.31452L5.90935 4.42361C5.88568 4.47722 5.84866 4.52384 5.80183 4.559C5.755 4.59417 5.69993 4.6167 5.64191 4.62444L2.35091 5.13766C2.01538 5.1892 1.70152 5.33557 1.44622 5.55956C1.19091 5.78355 1.00478 6.07586 0.909701 6.40212C0.803511 6.73059 0.78962 7.08198 0.869547 7.41783C0.949475 7.75367 1.12014 8.06103 1.36286 8.30626L3.80697 10.7236C3.84869 10.7646 3.87992 10.8151 3.89803 10.8708C3.91613 10.9265 3.92057 10.9857 3.91098 11.0434L3.35381 14.4649C3.29901 14.8066 3.33936 15.1567 3.47042 15.4769C3.60148 15.7971 3.81818 16.0749 4.0967 16.2798C4.39462 16.5103 4.76024 16.6358 5.13674 16.6368C5.43003 16.6352 5.71837 16.5611 5.97621 16.4211L8.94777 14.7996C8.99859 14.7703 9.05624 14.7548 9.11492 14.7548C9.1736 14.7548 9.23125 14.7703 9.28207 14.7996L12.2536 16.4063C12.5478 16.566 12.8818 16.637 13.2154 16.6106C13.549 16.5842 13.8677 16.4615 14.1331 16.2575C14.4116 16.0509 14.6282 15.7717 14.7592 15.4504C14.8901 15.1291 14.9306 14.7779 14.876 14.4352L14.304 11.0211C14.2935 10.9628 14.2967 10.9028 14.3135 10.846C14.3302 10.7892 14.3601 10.7371 14.4006 10.6939L16.6441 8.26907ZM13.2565 9.63022C13.0451 9.84322 12.8866 10.1029 12.7937 10.3884C12.7008 10.6739 12.6761 10.9772 12.7216 11.274L13.2937 14.6955C13.3074 14.7616 13.3021 14.8302 13.2784 14.8934C13.2547 14.9566 13.2137 15.0118 13.16 15.0525C13.1046 15.0884 13.0401 15.1075 12.9742 15.1075C12.9083 15.1075 12.8438 15.0884 12.7885 15.0525L9.81695 13.4459C9.5617 13.3066 9.27563 13.2336 8.98491 13.2336C8.6942 13.2336 8.40813 13.3066 8.15288 13.4459L5.18132 15.0674C5.126 15.1033 5.0615 15.1223 4.99559 15.1223C4.92969 15.1223 4.86519 15.1033 4.80987 15.0674C4.75411 15.0282 4.71104 14.9735 4.68596 14.91C4.66088 14.8466 4.65489 14.7772 4.66872 14.7104L5.29275 11.2963C5.34111 11.0013 5.31995 10.699 5.23095 10.4136C5.14196 10.1282 4.98759 9.86761 4.78016 9.65254L2.38062 7.23518C2.33783 7.18449 2.30968 7.12305 2.29921 7.05751C2.28873 6.99197 2.29634 6.92481 2.32119 6.86328C2.34032 6.79782 2.37777 6.73922 2.42911 6.69441C2.48045 6.64959 2.54355 6.62043 2.61092 6.61039L5.90192 6.1046C6.18596 6.05339 6.45333 5.9339 6.68107 5.75641C6.90881 5.57891 7.09012 5.34872 7.20941 5.0856L8.69519 1.96907C8.72125 1.90768 8.76468 1.85526 8.82011 1.81826C8.87555 1.78126 8.94058 1.76129 9.0072 1.7608C9.07425 1.7592 9.1403 1.77738 9.1971 1.81309C9.25391 1.8488 9.29896 1.90046 9.32664 1.96163L10.8124 5.07072C10.9377 5.33594 11.1256 5.56663 11.3599 5.74287C11.5942 5.91911 11.8678 6.03561 12.1571 6.08229L15.4555 6.5732C15.5216 6.58129 15.5838 6.60898 15.6341 6.65272C15.6844 6.69645 15.7205 6.75423 15.7378 6.81865C15.7612 6.88373 15.7653 6.95423 15.7495 7.02157C15.7336 7.08892 15.6986 7.15021 15.6486 7.19799L13.2565 9.63022Z'
            fill='black'
          />
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='18'
          height='18'
          viewBox='0 0 18 18'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.9452 7.81665C17.8588 8.18586 17.6731 8.52435 17.4083 8.79546L14.9404 11.4627C14.8959 11.5103 14.8631 11.5676 14.8446 11.6301C14.8262 11.6926 14.8226 11.7586 14.8342 11.8227L15.4634 15.5782C15.5234 15.9552 15.479 16.3414 15.3349 16.6949C15.1908 17.0483 14.9526 17.3554 14.6463 17.5827C14.3543 17.8072 14.0037 17.9421 13.6367 17.9711C13.2698 18.0002 12.9023 17.9221 12.5788 17.7464L9.31008 15.9791C9.25418 15.9468 9.19077 15.9298 9.12622 15.9298C9.06167 15.9298 8.99825 15.9468 8.94235 15.9791L5.67364 17.7627C5.39001 17.9167 5.07283 17.9982 4.75022 18C4.33607 17.9989 3.93389 17.8608 3.60617 17.6073C3.29981 17.3819 3.06144 17.0763 2.91727 16.7241C2.7731 16.3719 2.72872 15.9867 2.78899 15.6109L3.40188 11.8473C3.41244 11.7837 3.40755 11.7186 3.38764 11.6574C3.36772 11.5961 3.33336 11.5406 3.28747 11.4955L0.598955 8.83637C0.331959 8.56662 0.144227 8.22853 0.0563066 7.8591C-0.0316136 7.48967 -0.0163331 7.10314 0.100476 6.74182C0.205066 6.38293 0.40981 6.06139 0.690642 5.815C0.971474 5.56861 1.31672 5.40761 1.6858 5.35092L5.3059 4.78637C5.36973 4.77786 5.43031 4.75307 5.48182 4.71439C5.53333 4.67571 5.57406 4.62443 5.60009 4.56546L7.23445 1.14546C7.38774 0.8033 7.63684 0.512983 7.95158 0.309679C8.26631 0.106376 8.63318 -0.0011908 9.00772 9.94399e-06C9.37536 0.0063096 9.73374 0.116385 10.0417 0.317575C10.3496 0.518764 10.5945 0.802894 10.7483 1.13728L12.3827 4.5491C12.4093 4.60762 12.4502 4.6585 12.5016 4.69709C12.553 4.73569 12.6133 4.76076 12.6769 4.77001L16.3051 5.31001C16.6746 5.36807 17.0202 5.52943 17.3021 5.7755C17.584 6.02157 17.7908 6.34236 17.8986 6.70092C18.0155 7.0616 18.0317 7.44745 17.9452 7.81665ZM13.4508 16.3092L13.168 16.2578C13.2287 16.2969 13.2993 16.3177 13.3715 16.3177C13.3983 16.3177 13.4248 16.3148 13.4508 16.3092Z'
            fill='#1C70EE'
          />
        </svg>
      )}
    </Button>
  );
};

export default Save;
